export default {
  isMIPIH: false,
  BO_IS_V2: false,
  franceConnectData: null,
  edpv3UserMessage: '',
};



// WEBPACK FOOTER //
// ./src/store/modules/authentification/state.js